"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  olivemagazine: {
    domain: 'olivemagazine.com',
    theme: 'im-olive-theme',
    adobeFontsId: 'qlz3nrr'
  },
  radiotimes: {
    theme: 'im-rt-theme',
    domain: 'radiotimes.com',
    adobeFontsId: 'fer7rij',
    language: 'en-GB',
    dateTimeFormat: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  radiotimesmoney: {
    theme: 'im-rtmoney-theme',
    domain: 'radiotimesmoney.com',
    adobeFontsId: 'fer7rij'
  },
  slate: {
    domain: 'im-slate.com',
    theme: 'im-slate-theme',
    adobeFontsId: 'sts5pxq'
  },
  historyextra: {
    theme: 'im-historyextra-theme',
    domain: 'historyextra.com',
    adobeFontsId: 'jgm6vxd'
  },
  gardenersworld: {
    theme: 'im-gw-theme',
    domain: 'gardenersworld.com',
    adobeFontsId: 'jrx3jsy',
    language: 'en-GB',
    dateTimeFormat: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  policies: {
    theme: 'im-slate-theme',
    domain: 'policies.immediate.co.uk',
    adobeFontsId: 'snd2ukk'
  },
  madeformums: {
    theme: 'im-madeformums-theme',
    domain: 'madeformums.com',
    adobeFontsId: 'sqa2rfw'
  },
  bbcgoodfood: {
    domain: 'bbcgoodfood.com',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'xij0cqx'
  },
  junior: {
    theme: 'im-junior-theme',
    domain: 'juniormagazine.co.uk',
    adobeFontsId: 'qdj6zdx'
  },
  therecommended: {
    theme: 'im-therecommended-theme',
    domain: 'therecommended.com',
    adobeFontsId: 'gug4ypu'
  },
  viva: {
    theme: 'bmp-viva-theme',
    domain: 'viva.pl',
    adobeFontsId: 'cvt8iwj',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  party: {
    theme: 'bmp-party-theme',
    domain: 'party.pl',
    adobeFontsId: 'ogg0pql',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  varimerychle: {
    domain: 'varimerychle.cz',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'wkp2jvw',
    language: 'cs-CZ'
  },
  platosricos: {
    domain: 'platosricos.es',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'yqi8jys',
    language: 'es-ES',
    dateTimeFormat: {
      dateStyle: 'full'
    }
  },
  wizaz: {
    theme: 'bmp-wizaz-theme',
    domain: 'wizaz.pl',
    adobeFontsId: 'hbs6gcb',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  mamotoja: {
    theme: 'bmp-mamotoja-theme',
    domain: 'mamotoja.pl',
    adobeFontsId: 'qev3hjz',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  saveurs: {
    theme: 'bb-saveurs-theme',
    domain: 'saveurs-magazine.fr',
    adobeFontsId: 'sts5pxq',
    language: 'fr-FR',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  kobieta: {
    theme: 'bmp-kobieta-theme',
    domain: 'kobieta.pl',
    adobeFontsId: 'nns1bbi',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  'national-geographic-pl': {
    theme: 'bmp-nationalgeographic-theme',
    domain: 'national-geographic.pl',
    adobeFontsId: 'bxi4upb',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  glamour: {
    theme: 'im-glamour-theme',
    domain: 'glamour.pl',
    adobeFontsId: 'lmw7ypp',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  'elle-pl': {
    theme: 'bmp-elle-theme',
    domain: 'elle.pl',
    adobeFontsId: 'hgr3hmn',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  polki: {
    theme: 'im-slate-theme',
    domain: 'polki.pl',
    adobeFontsId: 'sts5pxq',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  mojegotowanie: {
    theme: 'im-slate-theme',
    domain: 'mojegotowanie.pl',
    adobeFontsId: 'sts5pxq',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  }
};
exports.default = _default;